import { combineReducers, configureStore } from "@reduxjs/toolkit";
import authReducer from "../store/slices/auth";
import amenityReducer from "../store/slices/amenity"
import organizationReducer from "../store/slices/organization"
import travelhotelReducer from "../store/slices/travelhotel"
import roomTypeReducer from "../store/slices/roomtype"
import vehicleTypeReducer from "../store/slices/vehicletype"
import placeReducer from "../store/slices/place"
import ferryReducer from "../store/slices/ferry"
import packageCategoryReducer from "../store/slices/packagecategory"
import packageReducer from "../store/slices/package"
import activityReducer from "../store/slices/activity"
import staffReducer from "../store/slices/staff";
import vendorReducer from "../store/slices/vendor";
import leadReducer from "../store/slices/leads";
import expenseReducer from "../store/slices/expense";
import amenityuserReducer from "../store/slices/amenityhotel";
import hotelReducer from "../store/slices/hotel";
import quotationReducer from "../store/slices/quotation";
import bookingReducer from "../store/slices/booking";
import agentReducer from "../store/slices/agent"

const rootReducer = combineReducers({
  auth: authReducer,
  amenity:amenityReducer,
  organization:organizationReducer,
  travelHotel:travelhotelReducer,
  hotel : hotelReducer,
  roomType:roomTypeReducer,
  vehicleType:vehicleTypeReducer,
  place:placeReducer,
  ferry:ferryReducer,
  packageCategory:packageCategoryReducer,
   package:packageReducer,
   activity:activityReducer,
   staff:staffReducer,
   vendor:vendorReducer,
   lead:leadReducer,
   expense:expenseReducer,
   amenityuser:amenityuserReducer,
   quotation:quotationReducer,
   booking:bookingReducer,
   agent:agentReducer

});

const store = configureStore({
  reducer: rootReducer,
  devTools: true,
});
export default store;
